import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import $ from "jquery";
import { GrGroup } from "react-icons/gr";
import { FiUsers } from "react-icons/fi";
import { Link } from "react-router-dom";
import { AiOutlineUsergroupAdd } from "react-icons/ai";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
    };
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {

      if (window.innerWidth <= 768) {
        document.body.classList.remove("sidebar-enable");
      } 
    $("#side-menu a").each(function () {
      if (this.href === window.location.href) {
        $(this).addClass("active");
        $(this).parent().addClass("mm-active"); // add active to li of the current link
        $(this).parent().parent().addClass("mm-show");
        $(this).parent().parent().prev().addClass("active"); // add active class to an anchor
        $(this).parent().parent().parent().addClass("mm-active");
        $(this).parent().parent().parent().parent().addClass("mm-show"); // add active to li of the current link
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass("mm-active");
      }
    });
    $(".nav-second-level").removeClass("mm-show").addClass("mm-collapse");
    const { type } = this.props;

    if (type === "profiles") {
      $("#profilesGrp").removeClass("mm-collapse").addClass("mm-show");
    }
  }

  handleClick(e) {
    if ($(e.target).next().hasClass("mm-collapse")) {
      $(".nav-second-level").removeClass("mm-show").addClass("mm-collapse");
      $(e.target).next().removeClass("mm-collapse").addClass("mm-show");
    } else {
      $(".nav-second-level").removeClass("mm-show").addClass("mm-collapse");
    }
  }
  render() {
    return (
      <div className="left-side-menu">
        <style>
          {`
            .left-side-menu .metismenu a {
              color: inherit; 
              text-decoration: none; 
            }

            .left-side-menu .metismenu a:hover {
              color: #0BAAE5 !important; 
            }

            .left-side-menu .metismenu li.mm-active > a {
              color: #0BAAE5 !important; 
            }
          `}
        </style>
        <Scrollbars style={{ width: "100%", height: "100%" }}>
          <div id="sidebar-menu">
            <ul className="metismenu" id="side-menu">
              <li>
                <Link to="/organisation/dashboard">
                  <i className="fe-airplay"></i> <span>Dashboard</span>
                </Link>{" "}
              </li>

              <li>
                <a className="groupMenu" href="#" onClick={this.handleClick}>
                  <i className="fas fa-users"></i> Profiles
                  <span className="menu-arrow"></span>
                </a>
                <ul
                  id="profilesGrp"
                  className="nav-second-level"
                  aria-expanded="false"
                >
                  <li>
                    <Link to="/organisation/customer">Customers</Link>
                  </li>
                  <li>
                    <Link to="/organisation/members">Volunteers</Link>
                  </li>
                  <li>
                    {/* <Link to="/profiles/employees">Employeess</Link> */}
                    <Link to="/organisation/employees">Employees</Link>
                  </li>
                </ul>
              </li>
              <li>
                {" "}
                <Link to="/organisation/survey">
                  <i className="fe-file-text"></i> <span>Survey</span>
                </Link>{" "}
              </li>

              <li>
                {" "}
                <Link to="/organisation/subscription">
                  <i className="fa fa-book fa-fw"></i> <span>Subscription</span>
                </Link>{" "}
              </li>

              <li>
                {" "}
                <Link to="/organisation/leads">
                  <i className="fa fa-tasks"></i> <span>Your Leads</span>
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/organisation/gallery">
                  <i className="fa fa-camera-retro" aria-hidden="true"></i>{" "}
                  <span>Gallery</span>
                </Link>{" "}
              </li>
              <li>
                <Link to="/organisation/marketplace">
                <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>
                  {/* <img
                    src="/assets/icons/marketplace.jpg"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "17px",
                      filter: "grayscale(100%)",
                      
                    }}
                    alt="Market Place Icon"
                  /> */}
                  <span>Market Place</span>
                </Link>
              </li>

              <li>
                <Link to="/organisation/customerSupport">
                  <i className="fa fa-headphones" aria-hidden="true"></i>
                  <span>Customer Support</span>
                </Link>
              </li>
            </ul>
          </div>

          <div className="clearfix"></div>
        </Scrollbars>
        {/* </div> */}
      </div>
    );
  }
}

export default Sidebar;
